import ErrorHandler from "@/helpers/handlers/error";
import { store } from "../../store/store";
import { i18n } from "../../main";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";
import { endpoints } from "@/config/endpoints";
const UNPAID_SUBSCRIPTION = "unpaid_subscription";

const forceLogout = async error => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.COMPANY_ID);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.LOCATIONS_IMPORT_STATUS);
  await store.dispatch("auth/logout");
  ErrorHandler.displayError(error);
};

export default async (service, customErrorMessage, routeName) => {
  try {
    const { data } = await service;
    return data;
  } catch (error) {
    if (
      error.response &&
      error.response.status === 500 &&
      error.config.url === endpoints.wizard.company.profile
    ) {
      forceLogout(error);
      return;
    }

    if (error.response && error.response.status === 401) {
      forceLogout(error);
      return;
    }

    if (error.response && error.response.status === 402) {
      const isUnpaidSubscription =
        store.getters["company/isUnpaidSubscription"];
      if (isUnpaidSubscription) {
        return; // Do not show modal if user hasn't selected a subscription plan
      }
      if (error.response.data.detail === UNPAID_SUBSCRIPTION) {
        const data = {
          text: i18n.t("message.service.accountSuspended")
        };
        store.dispatch("settings/openModal", data);
      } else {
        const data = {
          text: i18n.t("message.service.subscriptionPlanExpired"),
          path: "subscription-settings",
          buttonText: i18n.t("message.common.settings")
        };
        if (routeName !== "subscription-settings") {
          store.dispatch("settings/openModal", data);
        }
      }

      return;
    }

    if (error.response && error.response.status === 429) {
      const data = {
        text:
          customErrorMessage || i18n.t("message.service.wrongSubscriptionPlan"),
        buttonText: "OK"
      };

      store.dispatch("settings/openModal", data);
      return;
    }

    ErrorHandler.displayError(error);
    throw error;
  }
};
